import React, { useState, useEffect } from 'react'
import { Banner, Button, Collapsible, Layout, Icon, Modal, Card, InlineStack, BlockStack, Text, Grid } from "@shopify/polaris";
import mail from "../images/gmail.png";
import { DI, DIProps } from '../../../../Core';
import { CirclePlusOutlineMinor, CircleMinusOutlineMinor, PlayCircleMajor } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Support = (props: DIProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [video, setvideo] = useState<any>({ isOpen: false, idToSet: "" })
    const [faq_section, setfaq_section] = useState<any>(
        {
            faq_section_one: [
                {
                    id: 1,
                    show: true,
                    video_id: "https://www.youtube.com/embed/vETQqtJCZZY",
                    question: t("Listings vs Offers"),
                    answer:
                        `${t("Amazon allows multiple sellers to sell the same items from a single shared product listing page. There are two different types of listings- ‘New Listings’ and ‘Offer Listings’.  New Listings are new products uploaded by sellers on Amazon and have unique barcodes. On ‘New Listings’ the seller has access to give details related to the Title, Description, Images, & Product Identifiers such as EAN or UPC. All these details will be available on the Amazon product page when a customer searches with a relevant keyword. On the other hand, Offer Listings are those listings that are already available on Amazon and sellers can only put details related to inventory quantity and fulfilment options.")}
                       ${<br />} ${t("Every unique product has only one listing page on Amazon but may have multiple sellers extending different ‘Offer values’ of the same product.")}`,
                },
                {
                    id: 2,
                    show: false,
                    video_id: "https://www.youtube.com/embed/H4qpv98npN0",
                    question: t("Know product Categories and how to apply them"),
                    answer: t("Check out the multiple ways using which Shopify sellers can add/edit categories to the CedCommerce Amazon Channel app. Selling has become way easier than what it used to be. Get ahead of the competition with the best tools at your disposal."),
                },
            ],
            faq_section_two: [
                {
                    id: 3,
                    show: false,
                    video_id: "https://www.youtube.com/embed/nrXODfkG_70",
                    question: t("Get along with Templates and the way they work"),
                    answer: t("Templates do matter to sellers who are looking for ways to improve their selling spree. Hop into the video to find out what templates really do, what kind of templates are out there and their intricacies. The CedCommerce Amazon Channel app is yet another promising solution that aims to help Shopify sellers the best way possible.Managing templates, orders, listings, bulk uploads, etc, you can now manage all the things you want from a single platform, the CedCommerce Amazon Channel app."),
                },
                {
                    id: 4,
                    show: false,
                    video_id: "https://www.youtube.com/embed/-C5kG8dqFkM",
                    question: t("Adding an Amazon account: The processes involved"),
                    answer: t("In case you’re wondering how to add an Amazon account to the CedCommerce Amazon Channel app, here’s a short video that’ll clear your doubts. It’s time for you to step up your Shopify selling game with the CedCommerce Amazon Channel app."),
                },
            ]
        })

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const renderSupportCards = (icon: any, heading: string, buttonText: string, subheading: string,) => {
        const redirectTo = (recievedHeading: any) => {
            switch (recievedHeading) {
                case "Email":
                    window.open(`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`, '_blank');
                    break;
                default:
                    break;
            }
        };
        return (
            <Card roundedAbove='sm'>
                <Grid columns={{ xs: 1, sm: 3, md: 3, lg: 3 }}>
                    <Grid.Cell columnSpan={{ xs: 1, sm: 2, md: 2, lg: 2 }}>
                        <BlockStack gap="400">
                            <Text variant="heading2xl" as="h3">
                                {t(heading)}
                            </Text>
                            <Text as='span' tone="subdued">{t(subheading)}</Text>
                            <div>
                                <Button size="slim" onClick={() => { redirectTo(heading) }} >{t(buttonText)}</Button>
                            </div>
                        </BlockStack>
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1 }}>
                        <InlineStack align="end">
                            <img src={icon} />
                        </InlineStack>
                    </Grid.Cell>
                </Grid>
            </Card>
        );
    }

    const openvideoModal = (id: any) => {
        let temp = { ...video }
        temp.isOpen = true;
        temp.idToSet = id;
        setvideo(temp);
    };

    const closevideoModal = () => {
        let temp = { ...video }
        temp.isOpen = false;
        temp.idToSet = "";
        setvideo(temp);
    }

    const renderFaq = (faq_segment: any) => {
        return (
            <React.Fragment >
                {
                    Object.values(faq_section[faq_segment]).map((key: any) => {
                        return (
                            <Card roundedAbove='sm'>
                                <BlockStack gap="100">
                                    <InlineStack gap="400" align="space-between" wrap={false}>
                                        <Text as='p' fontWeight="semibold">{t(key["question"])}</Text>
                                        <Button
                                            icon={key["show"] ? CircleMinusOutlineMinor : CirclePlusOutlineMinor}
                                            onClick={() => {
                                                let temp = { ...faq_section[faq_segment] }
                                                key["show"] = !key["show"];
                                                setfaq_section({ ...faq_section, temp })
                                            }}
                                            variant="plain" />
                                    </InlineStack>
                                    <Collapsible
                                        open={key["show"]}
                                        id="basic-collapsible"
                                        transition={{
                                            duration: "500ms",
                                            timingFunction: "ease-in-out",
                                        }}
                                        expandOnPrint
                                    >
                                        <BlockStack gap="200">
                                            <Text as='p' tone="subdued">
                                                <span dangerouslySetInnerHTML={{ __html: key["answer"] }}></span>
                                            </Text>
                                            <Banner tone="info">
                                                <BlockStack gap="200">
                                                    <Text as='p' fontWeight="semibold">
                                                        {t("Still Confused? Watch the step-by-step video guide")}
                                                    </Text>
                                                    <div
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            openvideoModal(key["video_id"]);
                                                        }}
                                                    >
                                                        <InlineStack gap="200" align='start'>
                                                            <div><Icon source={PlayCircleMajor} tone="critical" /></div>
                                                            <Text as="p" fontWeight="regular">{t("Play Video")}</Text>
                                                        </InlineStack>
                                                    </div>
                                                </BlockStack>
                                            </Banner>
                                        </BlockStack>
                                    </Collapsible>
                                </BlockStack>
                            </Card>
                        );
                    })}
            </React.Fragment>
        );
    }

    const renderModal = (video: any) => {
        let { isOpen, idToSet } = video;
        return (
            <Modal
                open={isOpen}
                onClose={() => closevideoModal()}
                title={undefined}
            >
                <Modal.Section>
                    <iframe
                        width="560"
                        height="315"
                        src={idToSet}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </Modal.Section>
            </Modal>
        );
    }

    return (
        <div className='card-box-shadow'>
            <BlockStack gap="400">
                {/* <Card roundedAbove='sm'>
                    <BlockStack gap="200">
                        <Text variant="headingMd" as="h6">{t("Please choose your preferred mode of communication")}</Text>
                        <Layout>
                            <Layout.Section variant='oneHalf'>
                                {renderSupportCards(
                                    whatsapp,
                                    "WhatsApp",
                                    "Start Chat",
                                    "Feel free to reach out to us on WhatsApp at any point of time."
                                )}
                            </Layout.Section>
                            <Layout.Section variant='oneHalf'>
                                {renderSupportCards(
                                    mail,
                                    "Email",
                                    "Mail Us",
                                    "You can also reach out to us via mail, here’s the address:"
                                )}
                            </Layout.Section>
                        </Layout>
                    </BlockStack>
                </Card> */}
                {renderSupportCards(
                    mail,
                    "Email",
                    "Mail Us",
                    "You can also reach out to us via mail, here’s the address:"
                )}
                <Card roundedAbove='sm'>
                    <BlockStack gap="300">
                        <InlineStack gap="100" align='space-between' blockAlign='center'>
                            <Text variant="heading2xl" as="p">{t("Frequently Asked Questions")}</Text>
                            <Button variant="plain" onClick={() => navigate('/panel/faq')}>{t("View all FAQs")}</Button>
                        </InlineStack>
                        <Layout>
                            <Layout.Section variant='oneHalf'>
                                <BlockStack gap="400">{renderFaq('faq_section_one')}</BlockStack>
                            </Layout.Section>
                            <Layout.Section variant='oneHalf'>
                                <BlockStack gap="400">{renderFaq('faq_section_two')}</BlockStack>
                            </Layout.Section>
                        </Layout>
                    </BlockStack>
                </Card>
            </BlockStack>
            {renderModal(video)}
        </div >
    );
}

export default DI(Support)